export default "__VITE_ASSET__28acd83e__"